import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatUnixDate'
})
export class FormatUnixDatePipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (!value || isNaN(value)) return 'N/A';

    try {
      const date = new Date(value * 1000); // convert seconds to milliseconds
      if (isNaN(date.getTime())) return 'N/A'; // invalid date

      const options: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      };

      const formatted = date.toLocaleDateString('en-US', options);
      return formatted.replace(',', '.');
    } catch {
      return 'N/A';
    }
  }
}
